<template>
  <div
    class="ipage"
    :class="page && (page.styles.classes + ' ipage_' + pagetitle)"
    :style="page && page.styles.style"
    v-if="page && 
      (
        (page.published ||
          $store.state.app.user.includes($store.state.auth.uid))) ||
      ($store.state.app.advanced.roles.admin &&
        $store.state.app.advanced.roles.admin.members &&
        $store.state.app.advanced.roles.admin.members.includes(
          $store.state.auth.uid
        ))
    "
  >
    <div
      v-if="page && page.automenu && page.components.length > 0"
      class="flex flexx wrap align-center p16 m8 container around sticky"
    >
      <b class="border-bottom b8">{{pagetitle.toUpperCase()}}<i v-if="$store.state.windowWidth < 540" class="fa fa-bars" @click="$set(show, pagetitle+'menu', !show[pagetitle+'menu'])"></i></b>
      <div
        v-for="(comp, compkey) in page.components"
        :key="'automenu' + pagetitle + comp.name + compkey"
      >
        <a
          v-if="show[pagetitle+'menu'] || $store.state.windowWidth >= 540"
          class="xs-font r8"
          :href="`#${
            pagetitle.norm() + '_' + comp.name.norm() + '_' + compkey
          }`"
          ><i class="fa fa-link r4"></i>{{ ((comp.props && comp.props.type) || comp.name).toUpperCase() }}</a
        >
      </div>
    </div>
    <icontent
      :class="(page.automenu && page.components.length > 0 ? 'flexw' : '')"
      :key="page.text"
      :content="page.text"
    />
    <component
      :id="pagetitle.norm() + '_' + comp.name.norm() + '_' + compkey"
      class="page_component "
      :class="
        pagetitle.norm() +
        '_' +
        comp.name.norm() +
        '_' +
        compkey +
        ' ' +
        (page.automenu && page.components.length > 0 ? ' flexw ' : ' ') + 
        (comp.styles.classes ? comp.styles.classes : '')
      "
      v-for="(comp, compkey) in page.components"
      :key="pagetitle + comp.name + compkey"
      :style="comp.styles.style"
      v-bind="comp.props"
      :is="comp.name"
    />
  </div>
  <div v-else class="label warn p32 m16">
    <h5 class="flex align-center b8">
      <i class="fas fa-exclamation-triangle r4" /> {{ pagetitle }} is
      unavialble.
    </h5>
    <code
      >If you think this is an error, check yourself before you wreck yourself,
      or somehow contact the app admin. Good luck!</code
    >
  </div>
</template>
<script>
export default {
  computed: {
    page() {
      return this.$store.state.app.pages[this.pagetitle];
    },
  },
  data () {
    return {
      show: {}
    }
  },
  props: { pagetitle: { type: String } },
  name: "ipage",
  created () {
    if (this.$store.state.app.pages[this.pagetitle].hook) {
      this.$store.state.app.pages[this.pagetitle].hook.from = 'Page: ' + this.pagetitle
      this.$store.dispatch('run', this.$store.state.app.pages[this.pagetitle].hook)
    }
  },
};
</script>